import { Exception } from '@zxing/library';
import { FCMServerService } from './fcmserver.service';
import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { NavController, Platform } from '@ionic/angular';
import { FCM } from "cordova-plugin-fcm-with-dependecy-updated/ionic/ngx";
import { NotificacionesService } from './notificaciones.service';
import { Observable } from '../classes/observable';
import { UniqueDeviceID } from '@ionic-native/unique-device-id/ngx';

import { LocalNotifications } from '@awesome-cordova-plugins/local-notifications/ngx';
import { NavigationExtras } from '@angular/router';
import { AngularFireMessaging } from '@angular/fire/messaging';

@Injectable({
  providedIn: 'root'
})
export class FcmService {

  currentMessage = new BehaviorSubject(null);
  constructor(
    public angularFireMessaging: AngularFireMessaging, private platform: Platform, public navCtrl: NavController, private fcm: FCM, private localnotif: LocalNotifications, public FCMServerservice: FCMServerService, public UniqueDeviceID: UniqueDeviceID, private notifService: NotificacionesService) {

    
  }
  receiveMessage() {
    this.angularFireMessaging.onMessage((payload) => {
      
      this.localnotif.schedule({
        id: 1,
        text: payload.notification.title,
        icon: 'file://assets/img/logo.svg',
        smallIcon: 'file://assets/img/logo.svg',
        priority: 2,
        data: { body: payload.notification.body, activity: payload.notification.activity },
        foreground: true,
        vibrate: true,
        lockscreen: true,
        group: "efectivoDigital",
        

      });
      
      this.guardar_notificacion(payload);
      this.currentMessage.next(payload);
    });
  }

  async createNotificationChannel() {
    if (this.platform.is('android') && this.platform.is('cordova')) {
      try {
        await this.fcm.createNotificationChannel({
          id: 'varios',
          name: 'Efectivo Digital',
          description: 'Notificaciones de Efectivo Digital',
          importance: 'high',
          visibility: 'public',
          vibration: true,
          lights: true
        });
      } catch (e) {
        console.log('[FCM] Error creando canal:', e);
      }
    }
  }

  async requestNotificationPermission() {
    if (this.platform.is('cordova')) {
      try {
        const hasPermission = await this.fcm.hasPermission();
        if (!hasPermission) {
          await this.fcm.requestPushPermission();
        }
      } catch (e) {
        console.log('[FCM] Error solicitando permiso:', e);
      }
    }
  }



  async getToken() {
    let token;
    this.platform.ready().then(async () => {
      
      // if (this.platform.is('android') && FCM.hasOwnProperty("getToken")) {
      if (this.platform.is('android') && this.platform.is('cordova')) {
        await this.createNotificationChannel();
        await this.requestNotificationPermission();
        await this.fcm.getToken().then(tok => {
          token = tok;
          
        });
        this.registerToken(token);
        
        await this.fcm.onTokenRefresh().subscribe((token) => {
          this.registerToken(token);
          
        });
        await this.onNotifications();
      }
      else if (this.platform.is('ios') && this.platform.is('cordova')) {
        
        await this.fcm.getToken().then(tok => {
          token = tok;
          
        });
        await this.fcm.requestPushPermission({
          ios9Support: {
            timeout: 10,  // How long it will wait for a decision from the user before returning `false`
            interval: 0.3 // How long between each permission verification
          }
        });
        this.registerToken(token);
        await this.fcm.onTokenRefresh().subscribe((token) => {
          this.registerToken(token);

        });
        await this.onNotifications();
      }
      else {
        
        let tok = await localStorage.getItem("tokenFCM");
        
        
        if (tok == null || tok == undefined) {
          
          this.angularFireMessaging.requestPermission.toPromise().then(data => {
            this.angularFireMessaging.requestToken.subscribe(data => {
              
              this.angularFireMessaging.getToken.subscribe(data => {
                
                this.receiveMessage();
                
                this.registerToken(data);
              })
            });

          }).catch(err => {
            
          })
        }
        else {
          token = tok.toString().replace("0.", "0");
        }
      }
    });
  }
  public clickNotif;
  unsub() {
    this.clickNotif.unsubscribe();
  }
  guardar_notificacion(data) {

    
    let notifs = [];
    let notif = {
      data: data.notification.body,
      nuevo: true,
      titulo: data.notification.title,
      fecha: Date(),
      activity:data.data.activity
    }
    notifs = JSON.parse(localStorage.getItem("notification"));
    if (!notifs) {
      notifs = [notif];
    }
    else {
      notifs.push(notif);
    }
    localStorage.setItem("notification", JSON.stringify(notifs));
  }
  subscripto = false;
  onNotifications() {
    if (!this.subscripto) {
      this.subscripto = true;
      return this.fcm.onNotification().subscribe(data => {

        if(data.wasTapped==true){
          Observable.notify("tapNoti",data.activity);
          return true;
        }

        // Generar ID entero para la notificación local
        const notifId = Math.floor(Math.random() * 100000) + 1;

        this.localnotif.schedule({
          id: notifId,
          title: data.title,
          text: data.body,
          icon: 'res://ic_notificacion',
          smallIcon: 'res://ic_notificacion',
          color: '007c68',
          priority: 2,
          data: { body: data.body, activity: data.activity, params: data.params },
          foreground: true,
          vibrate: true,
          wakeup: true,
          lockscreen: true,
          silent: false,
          launch: false,
          channel: 'varios'
        });

        this.clickNotif = this.localnotif.on("click").subscribe((notification) => {
          if (notification.data && notification.data.activity) {
            let params = notification.data.params;
            const navigationExtras: NavigationExtras = {
              queryParams: {
                param: JSON.stringify(params)
              }
            }
            this.unsub();
            this.navCtrl.navigateRoot(notification.data.activity, navigationExtras);
          }
        });

        Observable.notify("notificacion-nueva", false);
      });
    }
  }
  async registerToken(token) {
    if (!token)
      return false;
    // localStorage.setItem("tokenFCM", token);
    var tipo = "navegador_" + this.platform.platforms()[0];
    if (this.platform.is("android")) {
      tipo = "android";
    }
    else if (this.platform.is("ios")) {
      tipo = "ios";
    }
    var device;
    if (this.platform.is("ios") || this.platform.is("android")) {
      await this.UniqueDeviceID.get()
        .then((uuid: any) => {
           
          this.FCMServerservice.refreshToken(token, this.platform, uuid, tipo);
        })
        .catch((error: any) =>{
            
            device = Math.random() + Date.now().toString();
            
            this.FCMServerservice.refreshToken(token, this.platform, device, tipo);
          }
        );
    }
    else {
      device = Math.random() + Date.now().toString();
      this.FCMServerservice.refreshToken(token, this.platform, device, tipo);
    }

  }
  public async obtener_data_notificacion(){
    try{
      console.log(await this.fcm);
      return await this.fcm != undefined ? this.fcm.getInitialPushPayload(): null;
    }
    catch(e){ 
      return false;
    }

  }

}
